import MolecularResponseSummaryTable from './molecular-response-summary-table';

export default MolecularResponseSummaryTable;
